/**
 *
 * ClosedTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.black30};
    background: ${COLORS.black04};
    border-color: ${COLORS.black30};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};
  }
`;

function ClosedTag(props) {
  return <StyledTag label="Closed" {...props} />;
}

export default memo(ClosedTag);
